import cleanseNumber from "../cleanseNumber";

export default class {
    /**
     * Create an Event object which will be used for tracking.
     * @param {String} category
     * @param {String} action
     * @param {String} label
     * @param {BigInteger} price
     */
    constructor(category = 'Event Category', action = 'Event Action', label = 'Event Label', price = 0) {
        this.category = category;
        this.action = action;
        this.label = label;
        this.price = price;
    }

    /**
     * Send the event to Analytics
     */
    dispatch() {
        dataLayer.push({
            'event' : 'trackEvent',
            'eventCategory' : this.category,
            'eventAction' : this.action,
            'eventLabel' : this.label,
            'eventValue' : parseInt(cleanseNumber(this.price)),
        });
    }
}